import { useMyFinancialStatementById } from "api/Client/balance";
import { Spinner } from "components";
import { image_host } from "config/api_host";
import { FaCheck, FaTimes } from "react-icons/fa"; // أيقونات من FontAwesome
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiSandsOfTime, GiTakeMyMoney } from "react-icons/gi";
import { GrCart } from "react-icons/gr";
import { MdNumbers } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import ClientActionModal from "../ClientActionModal/ClientActionModal";

const openImageInPopup = (url, title, width = 600, height = 400) => {
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  const newWindow = window.open(
    "",
    title,
    `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
  );

  if (newWindow) {
    // كتابة HTML مخصص داخل النافذة المنبثقة
    newWindow.document.write(`
      <html>
        <head>
          <title>${title}</title>
        </head>
        <body style="margin: 0; padding: 0;">
          <img src="${url}" style="width: 100%; height: 100%; object-fit: contain;" />
        </body>
      </html>
    `);
    newWindow.document.close(); // إغلاق المستند لضمان ظهور المحتوى
  }
};
export default function MyFinancialStatementModal({
  isOpen,
  toggle,
  financialId,
}) {
  const {
    data: currentOrder,
    isSuccess: currentOrderIsSuccess,
    isFetching: currentOrderIsFetching,
  } = useMyFinancialStatementById(financialId);

  return (
    <ClientActionModal
      open={isOpen}
      close={toggle}
      size="small"
      title={"تفاصيل عملية"}
    >
      {currentOrderIsFetching ? (
        <div className="bg-whtext-white p-5 flex justify-center items-center rounded-md shadow-md mx-auto">
          <Spinner sm />
        </div>
      ) : (
        currentOrderIsSuccess && (
          <div className="grid grid-cols-1 gap-4 my-4">
            <div className="bg-mainLight/20 grid gap-1 h-fit text-white p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
              <div className="flex justify-between items-center flex-row-reverse">
                {" "}
                <h2
                  className="text-xl font-bold text-white"
                  style={{ direction: "ltr" }}
                >
                  {Number(Math.abs(currentOrder.data.amount)).toLocaleString()}{" "}
                  <span className="text-sm">
                    {currentOrder.data.order_type === "bankNotice"
                      ? currentOrder.data.currency_bank
                      : currentOrder.data.currency_customer}
                  </span>{" "}
                </h2>
                {currentOrder.data.order_state === "pending" ? (
                  <div className={`text-white items-center flex gap-3`}>
                    <div className="text-xl p-1 ">
                      <GiSandsOfTime />
                    </div>
                    <span className="font-bold">{"انتظار"}</span>
                  </div>
                ) : currentOrder.data.order_state === "approved" ||
                  currentOrder.data.order_state === "completed" ? (
                  <div className={`text-green-500 items-center flex gap-3`}>
                    <div className="text-xl p-1 ">
                      <FaCheck />
                    </div>
                    <span className="font-bold">{"مكتملة"}</span>
                  </div>
                ) : currentOrder.data.order_state === "rejected" ||
                  currentOrder.data.order_state === "canceled" ? (
                  <div className={`text-red-500 items-center flex gap-3`}>
                    <div className="text-xl p-1 ">
                      <FaTimes />
                    </div>
                    <span className="font-bold">{"مرفوضة"}</span>
                  </div>
                ) : null}
              </div>
              <div className={`text-white items-center flex gap-3`}>
                <div className="text-xl p-1 text-white">
                  <FaMoneyBillTransfer />
                </div>
                <span className="font-bold">
                  {currentOrder.data.order_type === "bankNotice"
                    ? "إيداع"
                    : currentOrder.data.order_type === "balanceRecharge"
                    ? "إيداع"
                    : currentOrder.data.order_type === "transaction"
                    ? "ارسال رصيد"
                    : currentOrder.data.order_type === "refund"
                    ? "مرتجع"
                    : currentOrder.data.order_type === "purchaseInvoice"
                    ? "سحب مبلغ"
                    : "- - -"}
                </span>
              </div>
              <div className={`text-white items-center flex gap-3`}>
                <div className="text-xl p-1 text-white">
                  <MdNumbers />
                </div>
                <span className="font-bold break-all">
                  {" "}
                  {currentOrder.data.uuid}
                </span>
              </div>
              <div className="text-white items-center text-sm flex gap-3">
                <div className="text-xl p-1 text-white">
                  {(currentOrder.data.order_type === "bankNotice" ||
                    currentOrder.data.order_type === "transaction" ||
                    currentOrder.data.order_type === "balanceRecharge") && (
                    <GiTakeMyMoney />
                  )}
                  {(currentOrder.data.order_type === "refund" ||
                    currentOrder.data.order_type === "purchaseInvoice") && (
                    <GrCart />
                  )}
                </div>{" "}
                <span className="font-bold">
                  {currentOrder.data.description}
                </span>
              </div>

              <div className="text-white items-center flex gap-3">
                <div className="text-xl p-1 text-white">
                  <SlCalender />
                </div>{" "}
                <span style={{ direction: "ltr" }} className="font-bold">
                  {" "}
                  {currentOrder.data.created_at}{" "}
                </span>
              </div>

              {currentOrder.data.order_type == "bankNotice" && (
                <div className="text-white items-center flex gap-3 z-20">
                  <div className="font-bold p-1 text-white">
                    الرصيد المضاف للحساب:
                  </div>{" "}
                  <span style={{ direction: "ltr" }} className="font-bold">
                    {Number(currentOrder.data.total_amount).toLocaleString()}{" "}
                    <span className="text-xs">
                      {currentOrder.data.currency_customer /* || "S.P" */}{" "}
                    </span>
                  </span>
                </div>
              )}

              <div className="text-white items-center flex gap-3 z-20">
                <div className="font-bold p-1 text-white">
                  الرصيد قبل العملية:
                </div>{" "}
                <span style={{ direction: "ltr" }} className="font-bold">
                  {Number(
                    currentOrder.data.total_before_operation
                  ).toLocaleString()}{" "}
                  <span className="text-xs">
                    {currentOrder.data.currency_customer /* || "S.P" */}{" "}
                  </span>
                </span>
              </div>
            </div>

            {!isEmpty(currentOrder.data.order_fields) && (
              <div className="bg-mainLight/80 p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
                <h5 className="text-center font-bold text-lg text-white mb-4">
                  معلومات الطلب
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                  {Object.entries(currentOrder.data.order_fields).map(
                    ([key, item]) => (
                      <div className="flex flex-col gap-1" key={key}>
                        <span className="text-sm font-semibold text-white ">
                          {item.name}
                        </span>
                        <span className="text-lg font-bold text-white">
                          {item.value}
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

            {(currentOrder.data.rejection_reason ||
              currentOrder.data.reason) && (
              <div className="bg-mainLight/80 p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
                <h5 className="text-center font-bold text-lg text-white mb-4">
                  {currentOrder.data.order_state === "rejected" ||
                  currentOrder.data.order_state === "canceled"
                    ? "سبب الرفض"
                    : "الملاحظات"}
                </h5>

                <h5
                  className="text-white font-bold text-center_"
                  dangerouslySetInnerHTML={{
                    __html: (
                      currentOrder.data.rejection_reason ||
                      currentOrder.data.reason ||
                      ""
                    ).replace(/\n/g, "<br />"),
                  }}
                ></h5>
              </div>
            )}

            {currentOrder.data.notify_image && (
              <div className="bg-mainLight/80 p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
                <h5 className="text-center font-bold text-lg text-white mb-4">
                  صورة الاشعار
                </h5>

                <img
                  onClick={() =>
                    openImageInPopup(
                      `${image_host}${currentOrder.data.notify_image}`,
                      `المركز: ${currentOrder.data.center_name} | رقم الاشعار: ${currentOrder.data.notify_number} |`,
                      800, // العرض
                      600 // الارتفاع
                    )
                  }
                  src={`${image_host}${currentOrder.data.notify_image}`}
                  className="rounded-xl cursor-pointer mx-auto"
                />
              </div>
            )}
          </div>
        )
      )}
    </ClientActionModal>
  );
}

function isEmpty(field) {
  // التحقق إذا كان غير معرّف أو يساوي null
  if (field === undefined || field === null) return true;

  // التحقق إذا كان كائنًا فارغًا
  if (typeof field === "object") {
    return Object.keys(field).length === 0;
  }

  // التحقق إذا كان مصفوفة فارغة
  if (Array.isArray(field)) {
    return field.length === 0;
  }

  // إذا كان نوعًا آخر
  return false;
}
